/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-interface, @typescript-eslint/naming-convention */
/**
 * ИС "Продовольствие"
 * Целями создания ИС «Учет идентификационных карт» являются упрощение и ускорение выдачи идентификационных карт
      и продовольствия по ним гражданам Ростовской области в период введения особого положения в регионе, а также учет
      выданных карт и продовольствия по ним для оперативного формирования плана обеспечения региона.
 *
 * OpenAPI spec version: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

export namespace Api {
	export interface ActualIssueProduct extends Api.Entity {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof ActualIssueProduct
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Идентификатор МО</p>
		 * @type {string}
		 * @memberof ActualIssueProduct
		 */
		municipalEntityId: string;
		values: Api.ActualIssueProductValues;
	}

	export interface ActualIssueProductForCitizenCategory {
		'BREAD': Api.ActualIssueProductForCitizenCategory.BREAD;
		'MEAT': Api.ActualIssueProductForCitizenCategory.MEAT;
		'FATS': Api.ActualIssueProductForCitizenCategory.FATS;
		'VEGETABLES': Api.ActualIssueProductForCitizenCategory.VEGETABLES;
		'SALT': Api.ActualIssueProductForCitizenCategory.SALT;
		'GROATS': Api.ActualIssueProductForCitizenCategory.GROATS;
		'FISH': Api.ActualIssueProductForCitizenCategory.FISH;
		'MILK': Api.ActualIssueProductForCitizenCategory.MILK;
		'SUGAR': Api.ActualIssueProductForCitizenCategory.SUGAR;
		'EGGS': Api.ActualIssueProductForCitizenCategory.EGGS;
		'TOILET_SOAP': Api.ActualIssueProductForCitizenCategory.TOILETSOAP;
		'LAUNDRY_SOAP': Api.ActualIssueProductForCitizenCategory.LAUNDRYSOAP;
		'DETERGENTS': Api.ActualIssueProductForCitizenCategory.DETERGENTS;
		'MATCHES': Api.ActualIssueProductForCitizenCategory.MATCHES;
		'KEROSENE': Api.ActualIssueProductForCitizenCategory.KEROSENE;
	}
	
	/**
	 * @export
	 * @namespace ActualIssueProductForCitizenCategory
	 */
	export namespace ActualIssueProductForCitizenCategory {
		export interface BREAD {
			/**
			 * @type {number}
			 * @memberof BREAD
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof BREAD
			 */
			actualConsumption: number;
		}
	
		export interface MEAT {
			/**
			 * @type {number}
			 * @memberof MEAT
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof MEAT
			 */
			actualConsumption: number;
		}
	
		export interface FATS {
			/**
			 * @type {number}
			 * @memberof FATS
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof FATS
			 */
			actualConsumption: number;
		}
	
		export interface VEGETABLES {
			/**
			 * @type {number}
			 * @memberof VEGETABLES
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof VEGETABLES
			 */
			actualConsumption: number;
		}
	
		export interface SALT {
			/**
			 * @type {number}
			 * @memberof SALT
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof SALT
			 */
			actualConsumption: number;
		}
	
		export interface GROATS {
			/**
			 * @type {number}
			 * @memberof GROATS
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof GROATS
			 */
			actualConsumption: number;
		}
	
		export interface FISH {
			/**
			 * @type {number}
			 * @memberof FISH
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof FISH
			 */
			actualConsumption: number;
		}
	
		export interface MILK {
			/**
			 * @type {number}
			 * @memberof MILK
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof MILK
			 */
			actualConsumption: number;
		}
	
		export interface SUGAR {
			/**
			 * @type {number}
			 * @memberof SUGAR
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof SUGAR
			 */
			actualConsumption: number;
		}
	
		export interface EGGS {
			/**
			 * @type {number}
			 * @memberof EGGS
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof EGGS
			 */
			actualConsumption: number;
		}
	
		export interface TOILETSOAP {
			/**
			 * @type {number}
			 * @memberof TOILETSOAP
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof TOILETSOAP
			 */
			actualConsumption: number;
		}
	
		export interface LAUNDRYSOAP {
			/**
			 * @type {number}
			 * @memberof LAUNDRYSOAP
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof LAUNDRYSOAP
			 */
			actualConsumption: number;
		}
	
		export interface DETERGENTS {
			/**
			 * @type {number}
			 * @memberof DETERGENTS
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof DETERGENTS
			 */
			actualConsumption: number;
		}
	
		export interface MATCHES {
			/**
			 * @type {number}
			 * @memberof MATCHES
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof MATCHES
			 */
			actualConsumption: number;
		}
	
		export interface KEROSENE {
			/**
			 * @type {number}
			 * @memberof KEROSENE
			 * minimum: 0
			 */
			couponsCount: number;
			/**
			 * @type {number}
			 * @memberof KEROSENE
			 */
			actualConsumption: number;
		}
	
	}

	export interface ActualIssueProductsAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданной записи</p>
		 * @type {string}
		 * @memberof ActualIssueProductsAdd200Response
		 */
		id: string;
	}

	export interface ActualIssueProductsFormReport200Response extends Api.PaginatedResponse {
		items: Api.GroupedActualIssueProduct[];
	}

	export interface ActualIssueProductValues {
		'CH': Api.ActualIssueProductForCitizenCategory;
		'AB_M': Api.ActualIssueProductForCitizenCategory;
		'AB_F': Api.ActualIssueProductForCitizenCategory;
		'P_M': Api.ActualIssueProductForCitizenCategory;
		'P_F': Api.ActualIssueProductForCitizenCategory;
	}

	export interface AddActualIssueProduct {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof AddActualIssueProduct
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Идентификатор МО</p>
		 * @type {string}
		 * @memberof AddActualIssueProduct
		 */
		municipalEntityId?: string;
		values: Api.AddActualIssueProductValues;
	}

	export interface AddActualIssueProductForCitizenCategory {
		'BREAD'?: Api.AddActualIssueProductForCitizenCategory.BREAD;
		'MEAT'?: Api.AddActualIssueProductForCitizenCategory.MEAT;
		'FATS'?: Api.AddActualIssueProductForCitizenCategory.FATS;
		'VEGETABLES'?: Api.AddActualIssueProductForCitizenCategory.VEGETABLES;
		'SALT'?: Api.AddActualIssueProductForCitizenCategory.SALT;
		'GROATS'?: Api.AddActualIssueProductForCitizenCategory.GROATS;
		'FISH'?: Api.AddActualIssueProductForCitizenCategory.FISH;
		'MILK'?: Api.AddActualIssueProductForCitizenCategory.MILK;
		'SUGAR'?: Api.AddActualIssueProductForCitizenCategory.SUGAR;
		'EGGS'?: Api.AddActualIssueProductForCitizenCategory.EGGS;
		'TOILET_SOAP'?: Api.AddActualIssueProductForCitizenCategory.TOILETSOAP;
		'LAUNDRY_SOAP'?: Api.AddActualIssueProductForCitizenCategory.LAUNDRYSOAP;
		'DETERGENTS'?: Api.AddActualIssueProductForCitizenCategory.DETERGENTS;
		'MATCHES'?: Api.AddActualIssueProductForCitizenCategory.MATCHES;
		'KEROSENE'?: Api.AddActualIssueProductForCitizenCategory.KEROSENE;
	}
	
	/**
	 * @export
	 * @namespace AddActualIssueProductForCitizenCategory
	 */
	export namespace AddActualIssueProductForCitizenCategory {
		export interface BREAD {
			/**
			 * @type {number}
			 * @memberof BREAD
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface MEAT {
			/**
			 * @type {number}
			 * @memberof MEAT
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface FATS {
			/**
			 * @type {number}
			 * @memberof FATS
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface VEGETABLES {
			/**
			 * @type {number}
			 * @memberof VEGETABLES
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface SALT {
			/**
			 * @type {number}
			 * @memberof SALT
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface GROATS {
			/**
			 * @type {number}
			 * @memberof GROATS
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface FISH {
			/**
			 * @type {number}
			 * @memberof FISH
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface MILK {
			/**
			 * @type {number}
			 * @memberof MILK
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface SUGAR {
			/**
			 * @type {number}
			 * @memberof SUGAR
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface EGGS {
			/**
			 * @type {number}
			 * @memberof EGGS
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface TOILETSOAP {
			/**
			 * @type {number}
			 * @memberof TOILETSOAP
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface LAUNDRYSOAP {
			/**
			 * @type {number}
			 * @memberof LAUNDRYSOAP
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface DETERGENTS {
			/**
			 * @type {number}
			 * @memberof DETERGENTS
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface MATCHES {
			/**
			 * @type {number}
			 * @memberof MATCHES
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
		export interface KEROSENE {
			/**
			 * @type {number}
			 * @memberof KEROSENE
			 * minimum: 0
			 */
			couponsCount?: number;
		}
	
	}

	export interface AddActualIssueProductValues {
		'CH': Api.AddActualIssueProductForCitizenCategory;
		'AB_M': Api.AddActualIssueProductForCitizenCategory;
		'AB_F': Api.AddActualIssueProductForCitizenCategory;
		'P_M': Api.AddActualIssueProductForCitizenCategory;
		'P_F': Api.AddActualIssueProductForCitizenCategory;
	}

	/**
	 * <p>Параметры для создания пункта выдачи карт</p>
	 */
	export interface AddCardIssuePoint {
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Номер пункта выдачи карт</p>
		 * @type {number}
		 * @memberof AddCardIssuePoint
		 */
		'number': number;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		locality: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		comment?: string;
		/**
		 * @description <p>Количество окон</p>
		 * @type {number}
		 * @memberof AddCardIssuePoint
		 */
		windowsCount: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof AddCardIssuePoint
		 */
		responsiblePersonId?: string;
	}

	/**
	 * <p>Параметры для создания гражданина</p>
	 */
	export interface AddCitizen {
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		surname: string;
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		name: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		patronymic?: string;
		/**
		 * @description <p>Пол</p>
		 * @type {Api.AddCitizen.Sex}
		 * @memberof AddCitizen
		 */
		sex: Api.AddCitizen.Sex;
		/**
		 * @description <p>Дата рождения</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		birthdate: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Населенный пункт</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		locality: string;
		/**
		 * @description <p>Улица</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		street: string;
		/**
		 * @description <p>Дом</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		house: string;
		/**
		 * @description <p>Квартира</p>
		 * @type {string}
		 * @memberof AddCitizen
		 */
		appartment?: string;
		/**
		 * @description <p>Категория</p>
		 * @type {Api.AddCitizen.Category}
		 * @memberof AddCitizen
		 */
		category: Api.AddCitizen.Category;
		documents: Api.AddCitizenDocument[];
	}
	
	/**
	 * @export
	 * @namespace AddCitizen
	 */
	export namespace AddCitizen {
		/**
		 * <p>Пол</p>
		 */
		export type Sex =
			'MALE' |
			'FEMALE'
		
		export namespace Sex {
			export enum Enum {
				MALE = 'MALE',
				FEMALE = 'FEMALE'
			}
		}
	
		/**
		 * <p>Категория</p>
		 */
		export type Category =
			'CH' |
			'AB_M' |
			'AB_F' |
			'P_M' |
			'P_F'
		
		export namespace Category {
			export enum Enum {
				CH = 'CH',
				ABM = 'AB_M',
				ABF = 'AB_F',
				PM = 'P_M',
				PF = 'P_F'
			}
		}
	
	}

	export interface AddCitizenDocument {
		/**
		 * @description <p>Тип документа</p>
		 * @type {Api.AddCitizenDocument.Type}
		 * @memberof AddCitizenDocument
		 */
		'type': Api.AddCitizenDocument.Type;
		/**
		 * @description <p>Серия</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		series?: string;
		/**
		 * @description <p>Номер</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		num?: string;
		/**
		 * @description <p>Кем выдан</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		issue?: string;
		/**
		 * @description <p>Дата выдачи</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		date?: string;
		/**
		 * @description <p>Название документа</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		name?: string;
		/**
		 * @description <p>desc</p>
		 * @type {string}
		 * @memberof AddCitizenDocument
		 */
		info?: string;
	}
	
	/**
	 * @export
	 * @namespace AddCitizenDocument
	 */
	export namespace AddCitizenDocument {
		/**
		 * <p>Тип документа</p>
		 */
		export type Type =
			'PASSPORT' |
			'OTHER'
		
		export namespace Type {
			export enum Enum {
				PASSPORT = 'PASSPORT',
				OTHER = 'OTHER'
			}
		}
	
	}

	/**
	 * <p>Параметры для создани�� записи о поставке</p>
	 */
	export interface AddProductSupply {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof AddProductSupply
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Количество</p>
		 * @type {number}
		 * @memberof AddProductSupply
		 */
		amount: number;
		/**
		 * @description <p>Продовольственная категория</p>
		 * @type {Api.AddProductSupply.Category}
		 * @memberof AddProductSupply
		 */
		category: Api.AddProductSupply.Category;
	}
	
	/**
	 * @export
	 * @namespace AddProductSupply
	 */
	export namespace AddProductSupply {
		/**
		 * <p>Продовольственная категория</p>
		 */
		export type Category =
			'BREAD' |
			'MEAT' |
			'FATS' |
			'VEGETABLES' |
			'SALT' |
			'GROATS' |
			'FISH' |
			'MILK' |
			'SUGAR' |
			'EGGS' |
			'TOILET_SOAP' |
			'LAUNDRY_SOAP' |
			'DETERGENTS' |
			'MATCHES' |
			'KEROSENE'
		
		export namespace Category {
			export enum Enum {
				BREAD = 'BREAD',
				MEAT = 'MEAT',
				FATS = 'FATS',
				VEGETABLES = 'VEGETABLES',
				SALT = 'SALT',
				GROATS = 'GROATS',
				FISH = 'FISH',
				MILK = 'MILK',
				SUGAR = 'SUGAR',
				EGGS = 'EGGS',
				TOILETSOAP = 'TOILET_SOAP',
				LAUNDRYSOAP = 'LAUNDRY_SOAP',
				DETERGENTS = 'DETERGENTS',
				MATCHES = 'MATCHES',
				KEROSENE = 'KEROSENE'
			}
		}
	
	}

	export interface AddressesSuggest200Response extends Api.PaginatedResponse {
		items: Api.AddressesSuggest200Response.Item[];
	}
	
	/**
	 * @export
	 * @namespace AddressesSuggest200Response
	 */
	export namespace AddressesSuggest200Response {
		export interface Item {
			/**
			 * @description <p>ID муниципального образования, соответствующее адресу</p>
			 * @type {string}
			 * @memberof Item
			 */
			municipalEntityId?: string;
			/**
			 * @description <p>Предлагаемый адрес</p>
			 * @type {Api.AddressesSuggest200Response.Item.Address}
			 * @memberof Item
			 */
			address: Api.AddressesSuggest200Response.Item.Address;
		}
		
		/**
		 * @export
		 * @namespace Item
		 */
		export namespace Item {
			/**
			 * <p>Предлагаемый адрес</p>
			 */
			export interface Address {
				/**
				 * @description <p>Населенный пункт</p>
				 * @type {string}
				 * @memberof Address
				 */
				locality?: string;
				/**
				 * @description <p>Улица</p>
				 * @type {string}
				 * @memberof Address
				 */
				street?: string;
				/**
				 * @description <p>Дом</p>
				 * @type {string}
				 * @memberof Address
				 */
				house?: string;
			}
		
		}
	
	}

	export type AddressesSuggestLevel =
		'locality' |
		'street' |
		'house'
	
	export namespace AddressesSuggestLevel {
		export enum Enum {
			Locality = 'locality',
			Street = 'street',
			House = 'house'
		}
	}

	/**
	 * <p>Параметры для создания торгового объекта</p>
	 */
	export interface AddSalesPoint {
		/**
		 * @description <p>Наименование хозяйствующего субъекта, осуществляющего торговую деятельность</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		name?: string;
		/**
		 * @description <p>ИНН хозяйствующего субъекта</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		inn?: string;
		/**
		 * @description <p>Тип</p>
		 * @type {Api.AddSalesPoint.Type}
		 * @memberof AddSalesPoint
		 */
		'type'?: Api.AddSalesPoint.Type;
		/**
		 * @description <p>Возможности по прикреплению населения (тыс. чел.)</p>
		 * @type {number}
		 * @memberof AddSalesPoint
		 */
		maxPopulation?: number;
		/**
		 * @description <p>Отметка об уведомлении</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		notificationMark?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		locality: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		comment?: string;
		/**
		 * @description <p>Площадь объекта</p>
		 * @type {number}
		 * @memberof AddSalesPoint
		 */
		area: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof AddSalesPoint
		 */
		responsiblePersonName?: string;
	}
	
	/**
	 * @export
	 * @namespace AddSalesPoint
	 */
	export namespace AddSalesPoint {
		/**
		 * <p>Тип</p>
		 */
		export type Type =
			'FOOD' |
			'NON_FOOD' |
			'MIXED'
		
		export namespace Type {
			export enum Enum {
				FOOD = 'FOOD',
				NONFOOD = 'NON_FOOD',
				MIXED = 'MIXED'
			}
		}
	
	}

	/**
	 * <p>Параметры для создания записи об использованных картах</p>
	 */
	export interface AddUsedCardsStat {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof AddUsedCardsStat
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Идентификатор торгового объекта</p>
		 * @type {string}
		 * @memberof AddUsedCardsStat
		 */
		salesPointId: string;
		values: Api.AddUsedCardsStat.Values;
	}
	
	/**
	 * @export
	 * @namespace AddUsedCardsStat
	 */
	export namespace AddUsedCardsStat {
		export interface Values {
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'CH'?: number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_M'?: number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_F'?: number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_M'?: number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_F'?: number;
		}
	
	}

	/**
	 * <p>Параметры для создания пользователя</p>
	 */
	export interface AddUser {
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		name: string;
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		surname: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		patronymic?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Статус пользователя</p>
		 * @type {Api.AddUser.Status}
		 * @memberof AddUser
		 */
		status?: Api.AddUser.Status;
		/**
		 * @description <p>Идентификатор роли</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		roleId: string;
		/**
		 * @description <p>Идентификатор контрольного вопроса</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		controlQuestionId?: string;
		/**
		 * @description <p>Идентификатор пункта выдачи карт</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		cardIssuePointId?: string;
		/**
		 * @description <p>Email пользователя, он же является логином</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		email: string;
		/**
		 * @description <p>Пароль пользователя</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		password: string;
		/**
		 * @description <p>Правильный ответ на выбранный контрольный вопрос</p>
		 * @type {string}
		 * @memberof AddUser
		 */
		controlAnswer?: string;
	}
	
	/**
	 * @export
	 * @namespace AddUser
	 */
	export namespace AddUser {
		/**
		 * <p>Статус пользователя</p>
		 */
		export type Status =
			'active' |
			'blocked'
		
		export namespace Status {
			export enum Enum {
				Active = 'active',
				Blocked = 'blocked'
			}
		}
	
	}

	export interface AuthGetControlQuestion200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Текст контрольного вопроса</p>
		 * @type {string}
		 * @memberof AuthGetControlQuestion200Response
		 */
		controlQuestion?: string;
	}

	export interface AuthLoginByRequest {
		email: string;
		loginType: Api.AuthLoginByRequest.LoginType;
		answer: string;
	}
	
	/**
	 * @export
	 * @namespace AuthLoginByRequest
	 */
	export namespace AuthLoginByRequest {
		export type LoginType =
			'control_question' |
			'auth_code'
		
		export namespace LoginType {
			export enum Enum {
				ControlQuestion = 'control_question',
				AuthCode = 'auth_code'
			}
		}
	
	}

	export interface AuthLoginRequest {
		email: string;
		password: string;
	}

	export interface AuthSuccessResponse {
		result: Api.AuthSuccessResponse.Result;
		/**
		 * @description <p>Идентификатор сессии, используется в качестве bearer токена в заголовке Authorization</p>
		 * @type {string}
		 * @memberof AuthSuccessResponse
		 */
		bearerToken: string;
		/**
		 * @description <p>Время окончания сессии</p>
		 * @type {string}
		 * @memberof AuthSuccessResponse
		 */
		expiredAt: string;
		/**
		 * @description <p>Идентификатор авторизованного пользователя</p>
		 * @type {string}
		 * @memberof AuthSuccessResponse
		 */
		userId: string;
	}
	
	/**
	 * @export
	 * @namespace AuthSuccessResponse
	 */
	export namespace AuthSuccessResponse {
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
	}

	/**
	 * <p>Пункт выдачи карт</p>
	 */
	export interface CardIssuePoint extends Api.Entity {
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Номер пункта выдачи карт</p>
		 * @type {number}
		 * @memberof CardIssuePoint
		 */
		'number': number;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		locality: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		comment?: string;
		/**
		 * @description <p>Количество окон</p>
		 * @type {number}
		 * @memberof CardIssuePoint
		 */
		windowsCount: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof CardIssuePoint
		 */
		responsiblePersonId?: string;
	}

	/**
	 * <p>Общие поля пунктов выдачи карт</p>
	 */
	export interface CardIssuePointCommonFields {
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Номер пункта выдачи карт</p>
		 * @type {number}
		 * @memberof CardIssuePointCommonFields
		 */
		'number'?: number;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		locality?: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		comment?: string;
		/**
		 * @description <p>Количество окон</p>
		 * @type {number}
		 * @memberof CardIssuePointCommonFields
		 */
		windowsCount?: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof CardIssuePointCommonFields
		 */
		responsiblePersonId?: string;
	}

	export interface CardIssuePointsAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданного пункта выдачи карт</p>
		 * @type {string}
		 * @memberof CardIssuePointsAdd200Response
		 */
		id: string;
	}

	export interface CardIssuePointsGetById200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Пункт выдачи карт</p>
		 * @type {Api.CardIssuePoint}
		 * @memberof CardIssuePointsGetById200Response
		 */
		object: Api.CardIssuePoint;
	}

	export interface CardIssuePointsGetList200Response extends Api.PaginatedResponse {
		items: Api.CardIssuePoint[];
	}

	export type CardIssuePointsGetListDirection =
		'asc' |
		'desc'
	
	export namespace CardIssuePointsGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type CardIssuePointsGetListOrderBy =
		'createdAt' |
		'number' |
		'windowsCount'
	
	export namespace CardIssuePointsGetListOrderBy {
		export enum Enum {
			CreatedAt = 'createdAt',
			Number = 'number',
			WindowsCount = 'windowsCount'
		}
	}

	/**
	 * <p>Гражданин</p>
	 */
	export interface Citizen extends Api.Entity {
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		surname: string;
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		name: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		patronymic?: string;
		/**
		 * @description <p>Пол</p>
		 * @type {Api.Citizen.Sex}
		 * @memberof Citizen
		 */
		sex: Api.Citizen.Sex;
		/**
		 * @description <p>Дата рождения</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		birthdate: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Населенный пункт</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		locality: string;
		/**
		 * @description <p>Улица</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		street: string;
		/**
		 * @description <p>Дом</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		house: string;
		/**
		 * @description <p>Квартира</p>
		 * @type {string}
		 * @memberof Citizen
		 */
		appartment?: string;
		/**
		 * @description <p>Категория</p>
		 * @type {Api.Citizen.Category}
		 * @memberof Citizen
		 */
		category: Api.Citizen.Category;
		/**
		 * @description <p>Идентификаторы опекунов</p>
		 * @type {string[]}
		 * @memberof Citizen
		 */
		guardianIds?: string[];
		/**
		 * @description <p>Идентификаторы иждивенцев</p>
		 * @type {string[]}
		 * @memberof Citizen
		 */
		dependentIds?: string[];
	}
	
	/**
	 * @export
	 * @namespace Citizen
	 */
	export namespace Citizen {
		/**
		 * <p>Пол</p>
		 */
		export type Sex =
			'MALE' |
			'FEMALE'
		
		export namespace Sex {
			export enum Enum {
				MALE = 'MALE',
				FEMALE = 'FEMALE'
			}
		}
	
		/**
		 * <p>Категория</p>
		 */
		export type Category =
			'CH' |
			'AB_M' |
			'AB_F' |
			'P_M' |
			'P_F'
		
		export namespace Category {
			export enum Enum {
				CH = 'CH',
				ABM = 'AB_M',
				ABF = 'AB_F',
				PM = 'P_M',
				PF = 'P_F'
			}
		}
	
	}

	/**
	 * <p>Категории граждан</p>
	 */
	export interface CitizenCategories {
		/**
		 * @type {number}
		 * @memberof CitizenCategories
		 */
		'CH': number;
		/**
		 * @type {number}
		 * @memberof CitizenCategories
		 */
		'AB_M': number;
		/**
		 * @type {number}
		 * @memberof CitizenCategories
		 */
		'AB_F': number;
		/**
		 * @type {number}
		 * @memberof CitizenCategories
		 */
		'P_M': number;
		/**
		 * @type {number}
		 * @memberof CitizenCategories
		 */
		'P_F': number;
	}

	export interface CitizenCategoriesGetObject200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Категории граждан</p>
		 * @type {Api.CitizenCategories}
		 * @memberof CitizenCategoriesGetObject200Response
		 */
		object: Api.CitizenCategories;
	}

	/**
	 * <p>Общие поля пользователя</p>
	 */
	export interface CitizenCommonFields {
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		surname?: string;
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		name?: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		patronymic?: string;
		/**
		 * @description <p>Пол</p>
		 * @type {Api.CitizenCommonFields.Sex}
		 * @memberof CitizenCommonFields
		 */
		sex?: Api.CitizenCommonFields.Sex;
		/**
		 * @description <p>Дата рождения</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		birthdate?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Населенный пункт</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		locality?: string;
		/**
		 * @description <p>Улица</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		street?: string;
		/**
		 * @description <p>Дом</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		house?: string;
		/**
		 * @description <p>Квартира</p>
		 * @type {string}
		 * @memberof CitizenCommonFields
		 */
		appartment?: string;
		/**
		 * @description <p>Категория</p>
		 * @type {Api.CitizenCommonFields.Category}
		 * @memberof CitizenCommonFields
		 */
		category?: Api.CitizenCommonFields.Category;
	}
	
	/**
	 * @export
	 * @namespace CitizenCommonFields
	 */
	export namespace CitizenCommonFields {
		/**
		 * <p>Пол</p>
		 */
		export type Sex =
			'MALE' |
			'FEMALE'
		
		export namespace Sex {
			export enum Enum {
				MALE = 'MALE',
				FEMALE = 'FEMALE'
			}
		}
	
		/**
		 * <p>Категория</p>
		 */
		export type Category =
			'CH' |
			'AB_M' |
			'AB_F' |
			'P_M' |
			'P_F'
		
		export namespace Category {
			export enum Enum {
				CH = 'CH',
				ABM = 'AB_M',
				ABF = 'AB_F',
				PM = 'P_M',
				PF = 'P_F'
			}
		}
	
	}

	export interface CitizenDependentsAddRequest {
		/**
		 * @description <p>Идентификатор опекуна</p>
		 * @type {string}
		 * @memberof CitizenDependentsAddRequest
		 */
		guardianId: string;
		/**
		 * @description <p>Идентификатор иждивенца</p>
		 * @type {string}
		 * @memberof CitizenDependentsAddRequest
		 */
		dependentId: string;
	}

	export interface CitizenDocument extends Api.Entity {
		/**
		 * @description <p>Тип документа</p>
		 * @type {Api.CitizenDocument.Type}
		 * @memberof CitizenDocument
		 */
		'type': Api.CitizenDocument.Type;
		/**
		 * @description <p>Серия</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		series?: string;
		/**
		 * @description <p>Номер</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		num?: string;
		/**
		 * @description <p>Кем выдан</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		issue?: string;
		/**
		 * @description <p>Дата выдачи</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		date?: string;
		/**
		 * @description <p>Название документа</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		name?: string;
		/**
		 * @description <p>desc</p>
		 * @type {string}
		 * @memberof CitizenDocument
		 */
		info?: string;
	}
	
	/**
	 * @export
	 * @namespace CitizenDocument
	 */
	export namespace CitizenDocument {
		/**
		 * <p>Тип документа</p>
		 */
		export type Type =
			'PASSPORT' |
			'OTHER'
		
		export namespace Type {
			export enum Enum {
				PASSPORT = 'PASSPORT',
				OTHER = 'OTHER'
			}
		}
	
	}

	export interface CitizenDocumentInfo {
		/**
		 * @description <p>Тип документа</p>
		 * @type {string}
		 * @memberof CitizenDocumentInfo
		 */
		'type': string;
		/**
		 * @description <p>Информация по документу</p>
		 * @type {string}
		 * @memberof CitizenDocumentInfo
		 */
		info: string;
		/**
		 * @description <p>Название документа</p>
		 * @type {string}
		 * @memberof CitizenDocumentInfo
		 */
		name: string;
	}

	export interface CitizenDocumentsGetListById200Response extends Api.ListResponse {
		items: Api.CitizenDocument[];
	}

	/**
	 * <p>Гражданин с документом</p>
	 */
	export interface CitizenFullInfo {
		/**
		 * @description <p>Гражданин</p>
		 * @type {Api.Citizen}
		 * @memberof CitizenFullInfo
		 */
		citizen: Api.Citizen;
		document: Api.CitizenDocumentInfo;
		municipalEntity: string;
		cardStatus?: Api.CitizenFullInfo.CardStatus;
	}
	
	/**
	 * @export
	 * @namespace CitizenFullInfo
	 */
	export namespace CitizenFullInfo {
		export type CardStatus =
			'new' |
			'active' |
			'completed'
		
		export namespace CardStatus {
			export enum Enum {
				New = 'new',
				Active = 'active',
				Completed = 'completed'
			}
		}
	
	}

	export interface CitizensAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданного гражданина</p>
		 * @type {string}
		 * @memberof CitizensAdd200Response
		 */
		id: string;
	}

	export interface CitizensGetById200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Гражданин</p>
		 * @type {Api.Citizen}
		 * @memberof CitizensGetById200Response
		 */
		object: Api.Citizen;
	}

	export interface CitizensGetList200Response extends Api.PaginatedResponse {
		items: Api.Citizen[];
	}

	export type CitizensGetListDirection =
		'asc' |
		'desc'
	
	export namespace CitizensGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type CitizensGetListOrderBy =
		'fullname' |
		'createdAt'
	
	export namespace CitizensGetListOrderBy {
		export enum Enum {
			Fullname = 'fullname',
			CreatedAt = 'createdAt'
		}
	}

	export interface CitizensWithInfoGetList200Response extends Api.PaginatedResponse {
		items: Api.CitizenFullInfo[];
	}

	export type CitizensWithInfoGetListCardStatus =
		'new' |
		'active' |
		'completed'
	
	export namespace CitizensWithInfoGetListCardStatus {
		export enum Enum {
			New = 'new',
			Active = 'active',
			Completed = 'completed'
		}
	}

	export type CitizensWithInfoGetListDirection =
		'asc' |
		'desc'
	
	export namespace CitizensWithInfoGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type CitizensWithInfoGetListOrderBy =
		'fullname' |
		'createdAt'
	
	export namespace CitizensWithInfoGetListOrderBy {
		export enum Enum {
			Fullname = 'fullname',
			CreatedAt = 'createdAt'
		}
	}

	export interface ConfirmDataForIdentityCard {
		/**
		 * @description <p>Месяц идентификационной карты</p>
		 * @type {number}
		 * @memberof ConfirmDataForIdentityCard
		 * minimum: 0
		 * maximum: 11
		 */
		month: number;
		/**
		 * @description <p>Год идентификационной карты</p>
		 * @type {number}
		 * @memberof ConfirmDataForIdentityCard
		 * minimum: 2022
		 */
		year: number;
		/**
		 * @description <p>ID гражданина</p>
		 * @type {string}
		 * @memberof ConfirmDataForIdentityCard
		 */
		citizenId: string;
		/**
		 * @description <p>ID пункта выдачи карточки</p>
		 * @type {string}
		 * @memberof ConfirmDataForIdentityCard
		 */
		cardIssuePointId: string;
	}

	export interface ConsumptionRates {
		'BREAD': Api.ConsumptionRates.BREAD;
		'MEAT': Api.ConsumptionRates.MEAT;
		'FATS': Api.ConsumptionRates.FATS;
		'VEGETABLES': Api.ConsumptionRates.VEGETABLES;
		'SALT': Api.ConsumptionRates.SALT;
		'GROATS': Api.ConsumptionRates.GROATS;
		'FISH': Api.ConsumptionRates.FISH;
		'MILK': Api.ConsumptionRates.MILK;
		'SUGAR': Api.ConsumptionRates.SUGAR;
		'EGGS': Api.ConsumptionRates.EGGS;
		'TOILET_SOAP': Api.ConsumptionRates.TOILETSOAP;
		'LAUNDRY_SOAP': Api.ConsumptionRates.LAUNDRYSOAP;
		'DETERGENTS': Api.ConsumptionRates.DETERGENTS;
		'MATCHES': Api.ConsumptionRates.MATCHES;
		'KEROSENE': Api.ConsumptionRates.KEROSENE;
	}
	
	/**
	 * @export
	 * @namespace ConsumptionRates
	 */
	export namespace ConsumptionRates {
		export interface BREAD {
			/**
			 * @type {number}
			 * @memberof BREAD
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof BREAD
			 * minimum: 0
			 * maximum: 30
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface MEAT {
			/**
			 * @type {number}
			 * @memberof MEAT
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof MEAT
			 * minimum: 0
			 * maximum: 4
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface FATS {
			/**
			 * @type {number}
			 * @memberof FATS
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof FATS
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface VEGETABLES {
			/**
			 * @type {number}
			 * @memberof VEGETABLES
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof VEGETABLES
			 * minimum: 0
			 * maximum: 10
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface SALT {
			/**
			 * @type {number}
			 * @memberof SALT
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof SALT
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface GROATS {
			/**
			 * @type {number}
			 * @memberof GROATS
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof GROATS
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface FISH {
			/**
			 * @type {number}
			 * @memberof FISH
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof FISH
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface MILK {
			/**
			 * @type {number}
			 * @memberof MILK
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof MILK
			 * minimum: 0
			 * maximum: 18
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface SUGAR {
			/**
			 * @type {number}
			 * @memberof SUGAR
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof SUGAR
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface EGGS {
			/**
			 * @type {number}
			 * @memberof EGGS
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof EGGS
			 * minimum: 0
			 * maximum: 2
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface TOILETSOAP {
			/**
			 * @type {number}
			 * @memberof TOILETSOAP
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof TOILETSOAP
			 * minimum: 0
			 * maximum: 1
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface LAUNDRYSOAP {
			/**
			 * @type {number}
			 * @memberof LAUNDRYSOAP
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof LAUNDRYSOAP
			 * minimum: 0
			 * maximum: 1
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface DETERGENTS {
			/**
			 * @type {number}
			 * @memberof DETERGENTS
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof DETERGENTS
			 * minimum: 0
			 * maximum: 1
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface MATCHES {
			/**
			 * @type {number}
			 * @memberof MATCHES
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof MATCHES
			 * minimum: 0
			 * maximum: 1
			 */
			couponsCountPerMonth?: number;
		}
	
		export interface KEROSENE {
			/**
			 * @type {number}
			 * @memberof KEROSENE
			 */
			averageRate?: number;
			/**
			 * @type {number}
			 * @memberof KEROSENE
			 * minimum: 0
			 * maximum: 1
			 */
			couponsCountPerMonth?: number;
		}
	
	}

	export interface ConsumptionRatesGetObject200Response extends Api.ObjectResponse {
		object: Api.ConsumptionRates;
	}

	export type ConsumptionRatesUpdateProductCategory =
		'BREAD' |
		'MEAT' |
		'FATS' |
		'VEGETABLES' |
		'SALT' |
		'GROATS' |
		'FISH' |
		'MILK' |
		'SUGAR' |
		'EGGS' |
		'TOILET_SOAP' |
		'LAUNDRY_SOAP' |
		'DETERGENTS' |
		'MATCHES' |
		'KEROSENE'
	
	export namespace ConsumptionRatesUpdateProductCategory {
		export enum Enum {
			BREAD = 'BREAD',
			MEAT = 'MEAT',
			FATS = 'FATS',
			VEGETABLES = 'VEGETABLES',
			SALT = 'SALT',
			GROATS = 'GROATS',
			FISH = 'FISH',
			MILK = 'MILK',
			SUGAR = 'SUGAR',
			EGGS = 'EGGS',
			TOILETSOAP = 'TOILET_SOAP',
			LAUNDRYSOAP = 'LAUNDRY_SOAP',
			DETERGENTS = 'DETERGENTS',
			MATCHES = 'MATCHES',
			KEROSENE = 'KEROSENE'
		}
	}

	/**
	 * <p>Нормативы на талоны для одной категории граждан</p>
	 */
	export interface ConsumptionStandard {
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'BREAD': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'MEAT': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'FATS': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'VEGETABLES': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'SALT': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'GROATS': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'FISH': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'MILK': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'SUGAR': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'EGGS': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'TOILET_SOAP': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'LAUNDRY_SOAP': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'DETERGENTS': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'MATCHES': number;
		/**
		 * @type {number}
		 * @memberof ConsumptionStandard
		 */
		'KEROSENE': number;
	}

	/**
	 * <p>Нормативы на талоны для всех категорий граждан</p>
	 */
	export interface ConsumptionStandards {
		/**
		 * @description <p>Нормативы на талоны для одной категории граждан</p>
		 * @type {Api.ConsumptionStandard}
		 * @memberof ConsumptionStandards
		 */
		'CH': Api.ConsumptionStandard;
		/**
		 * @description <p>Нормативы на талоны для одной категории граждан</p>
		 * @type {Api.ConsumptionStandard}
		 * @memberof ConsumptionStandards
		 */
		'AB_M': Api.ConsumptionStandard;
		/**
		 * @description <p>Нормативы на талоны для одной категории граждан</p>
		 * @type {Api.ConsumptionStandard}
		 * @memberof ConsumptionStandards
		 */
		'AB_F': Api.ConsumptionStandard;
		/**
		 * @description <p>Нормативы на талоны для одной категории граждан</p>
		 * @type {Api.ConsumptionStandard}
		 * @memberof ConsumptionStandards
		 */
		'P_M': Api.ConsumptionStandard;
		/**
		 * @description <p>Нормативы на талоны для одной категории граждан</p>
		 * @type {Api.ConsumptionStandard}
		 * @memberof ConsumptionStandards
		 */
		'P_F': Api.ConsumptionStandard;
	}

	export interface ConsumptionStandardsGetObject200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Нормативы на талоны для всех категорий граждан</p>
		 * @type {Api.ConsumptionStandards}
		 * @memberof ConsumptionStandardsGetObject200Response
		 */
		object: Api.ConsumptionStandards;
	}

	export interface ControlQuestion {
		/**
		 * @description <p>Идентификатор вопроса</p>
		 * @type {string}
		 * @memberof ControlQuestion
		 */
		id: string;
		/**
		 * @description <p>Текст вопроса</p>
		 * @type {string}
		 * @memberof ControlQuestion
		 */
		question: string;
	}

	/**
	 * <p>Общие поля всех сущностей</p>
	 */
	export interface Entity {
		/**
		 * @description <p>Идентификатор сущности</p>
		 * @type {string}
		 * @memberof Entity
		 */
		id: string;
		/**
		 * @description <p>Дата и время создания</p>
		 * @type {string}
		 * @memberof Entity
		 */
		createdAt: string;
		/**
		 * @description <p>Дата и время удаления</p>
		 * @type {string}
		 * @memberof Entity
		 */
		deletedAt?: string;
	}

	/**
	 * <p>Ошибка выполнения операции</p>
	 */
	export interface ErrorResponse {
		/**
		 * @description <p>Успешный результат операции</p>
		 * @type {Api.ErrorResponse.Result}
		 * @memberof ErrorResponse
		 */
		result: Api.ErrorResponse.Result;
		error: Api.ErrorResponse.Error;
	}
	
	/**
	 * @export
	 * @namespace ErrorResponse
	 */
	export namespace ErrorResponse {
		/**
		 * <p>Успешный результат операции</p>
		 */
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
		export interface Error {
			/**
			 * @description <p>Код (класс) ошибки</p>
			 * @type {Api.ErrorResponse.Error.Code}
			 * @memberof Error
			 */
			code?: Api.ErrorResponse.Error.Code;
			/**
			 * @description <p>Уникальный идентификатор ошибки</p>
			 * @type {string}
			 * @memberof Error
			 */
			uid?: string;
			/**
			 * @description <p>Описание ошибки</p>
			 * @type {string}
			 * @memberof Error
			 */
			message: string;
		}
		
		/**
		 * @export
		 * @namespace Error
		 */
		export namespace Error {
			/**
			 * <p>Код (класс) ошибки</p>
			 */
			export type Code =
				'NOT_IMPLEMENTED' |
				'INTERNAL_ERROR' |
				'OBJECT_NOT_FOUND' |
				'OBJECT_ALREADY_EXISTS' |
				'AUTHORIZATION_NEEDED' |
				'ACCESS_DENIED' |
				'INVALID_PARAMETER' |
				'NETWORK_ERROR'
			
			export namespace Code {
				export enum Enum {
					NOTIMPLEMENTED = 'NOT_IMPLEMENTED',
					INTERNALERROR = 'INTERNAL_ERROR',
					OBJECTNOTFOUND = 'OBJECT_NOT_FOUND',
					OBJECTALREADYEXISTS = 'OBJECT_ALREADY_EXISTS',
					AUTHORIZATIONNEEDED = 'AUTHORIZATION_NEEDED',
					ACCESSDENIED = 'ACCESS_DENIED',
					INVALIDPARAMETER = 'INVALID_PARAMETER',
					NETWORKERROR = 'NETWORK_ERROR'
				}
			}
		
		}
	
	}

	export interface GlobalSettings extends Api.Entity {
		/**
		 * @description <p>Идентификатор анонимной роли</p>
		 * @type {string}
		 * @memberof GlobalSettings
		 */
		anonymousRoleId?: string;
		/**
		 * @description <p>Время (указывается в формате UTC), до которого должна быть внесена информация в отчёты</p>
		 * @type {string}
		 * @memberof GlobalSettings
		 */
		reportsCloseTime?: string;
		/**
		 * @description <p>Количество дней до начала месяца, с которых должна формироваться идентификационная карта гражданина</p>
		 * @type {number}
		 * @memberof GlobalSettings
		 * minimum: 0
		 * maximum: 31
		 */
		cardActivationDelay?: number;
	}

	export interface GlobalSettingsGetObject200Response {
		/**
		 * @description <p>Успешный результат операции</p>
		 * @type {Api.ObjectResponse.Result}
		 * @memberof GlobalSettingsGetObject200Response
		 */
		result: Api.ObjectResponse.Result;
		object: Api.GlobalSettings;
	}

	export interface GroupedActualIssueProduct {
		/**
		 * @description <p>Идентификатор МО</p>
		 * @type {string}
		 * @memberof GroupedActualIssueProduct
		 */
		municipalEntityId: string;
		values: Api.ActualIssueProductValues;
	}

	/**
	 * <p>Сгруппированный отчёт об использованных картах</p>
	 */
	export interface GroupedUsedCardsStat {
		municipalEntity: Api.MunicipalEntity;
		salesPoint: Api.SalesPoint;
		values: Api.GroupedUsedCardsStat.Values;
	}
	
	/**
	 * @export
	 * @namespace GroupedUsedCardsStat
	 */
	export namespace GroupedUsedCardsStat {
		export interface Values {
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'CH': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_F': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_F': number;
		}
	
	}

	/**
	 * <p>Карточка гражданина</p>
	 */
	export interface IdentityCard {
		/**
		 * @description <p>Месяц идентификационной карты</p>
		 * @type {number}
		 * @memberof IdentityCard
		 * minimum: 0
		 * maximum: 11
		 */
		month: number;
		/**
		 * @description <p>Год идентификационной карты</p>
		 * @type {number}
		 * @memberof IdentityCard
		 * minimum: 2022
		 */
		year: number;
		/**
		 * @description <p>ID гражданина</p>
		 * @type {string}
		 * @memberof IdentityCard
		 */
		citizenId: string;
		/**
		 * @description <p>ID пункта выдачи карточки</p>
		 * @type {string}
		 * @memberof IdentityCard
		 */
		cardIssuePointId?: string;
		/**
		 * @description <p>Идентификатор сущности</p>
		 * @type {string}
		 * @memberof IdentityCard
		 */
		id: string;
		/**
		 * @description <p>Дата и время создания</p>
		 * @type {string}
		 * @memberof IdentityCard
		 */
		createdAt: string;
		/**
		 * @description <p>Дата и время подтверждения выдачи карты гражданину</p>
		 * @type {string}
		 * @memberof IdentityCard
		 */
		confirmedAt?: string;
	}

	/**
	 * <p>Общие поля для карточки гражданина</p>
	 */
	export interface IdentityCardCommonFields {
		/**
		 * @description <p>Месяц идентификационной карты</p>
		 * @type {number}
		 * @memberof IdentityCardCommonFields
		 * minimum: 0
		 * maximum: 11
		 */
		month?: number;
		/**
		 * @description <p>Год идентификационной карты</p>
		 * @type {number}
		 * @memberof IdentityCardCommonFields
		 * minimum: 2022
		 */
		year?: number;
		/**
		 * @description <p>ID гражданина</p>
		 * @type {string}
		 * @memberof IdentityCardCommonFields
		 */
		citizenId?: string;
		/**
		 * @description <p>ID пункта выдачи карточки</p>
		 * @type {string}
		 * @memberof IdentityCardCommonFields
		 */
		cardIssuePointId?: string;
	}

	export interface IdentityCardsConfirm200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Карточка гражданина</p>
		 * @type {Api.IdentityCard}
		 * @memberof IdentityCardsConfirm200Response
		 */
		object: Api.IdentityCard;
	}

	export interface IdentityCardsGetListByCitizenId200Response {
		items: Api.IdentityCard[];
	}

	export interface IdentityCardsPrint200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Карточка гражданина</p>
		 * @type {Api.IdentityCard}
		 * @memberof IdentityCardsPrint200Response
		 */
		object: Api.IdentityCard;
	}

	/**
	 * <p>Статистика выданных карт по одному муниципальному образованию</p>
	 */
	export interface IssuanceCardsStat {
		municipalEntity: Api.MunicipalEntity;
		/**
		 * @description <p>Пункт выдачи карт</p>
		 * @type {Api.CardIssuePoint}
		 * @memberof IssuanceCardsStat
		 */
		cardIssuePoint: Api.CardIssuePoint;
		values: Api.IssuanceCardsStat.Values;
	}
	
	/**
	 * @export
	 * @namespace IssuanceCardsStat
	 */
	export namespace IssuanceCardsStat {
		export interface Values {
			/**
			 * @type {number}
			 * @memberof Values
			 */
			'CH': number;
			/**
			 * @type {number}
			 * @memberof Values
			 */
			'AB_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 */
			'AB_F': number;
			/**
			 * @type {number}
			 * @memberof Values
			 */
			'P_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 */
			'P_F': number;
		}
	
	}

	export interface IssuanceCardsStatsFormReport200Response extends Api.SuccessResponse {
		object: Api.IssuanceCardsStatsFormReport200Response.Object;
	}
	
	/**
	 * @export
	 * @namespace IssuanceCardsStatsFormReport200Response
	 */
	export namespace IssuanceCardsStatsFormReport200Response {
		export interface Object {
			groupedByME: Api.IssuanceCardsStat[];
			groupedByCIP: Api.IssuanceCardsStatsFormReport200Response.Object.GroupedByCIP;
		}
		
		/**
		 * @export
		 * @namespace Object
		 */
		export namespace Object {
			export interface GroupedByCIP {
				/**
				 * @description <p>Порядковый номер начальной записи. Начинается с нуля.</p>
				 * @type {number}
				 * @memberof GroupedByCIP
				 */
				'from': number;
				/**
				 * @description <p>Количество записей в ответе</p>
				 * @type {number}
				 * @memberof GroupedByCIP
				 */
				count: number;
				/**
				 * @description <p>Общее количество записей в базе соответствующих фильтру</p>
				 * @type {number}
				 * @memberof GroupedByCIP
				 */
				total: number;
				items: Api.IssuanceCardsStat[];
			}
		
		}
	
	}

	export interface ListResponse {
		/**
		 * @description <p>Результат операции</p>
		 * @type {Api.ListResponse.Result}
		 * @memberof ListResponse
		 */
		result: Api.ListResponse.Result;
		items: Api.ListResponse.Item[];
	}
	
	/**
	 * @export
	 * @namespace ListResponse
	 */
	export namespace ListResponse {
		/**
		 * <p>Результат операции</p>
		 */
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
		/**
		 * <p>Список записей</p>
		 */
		export interface Item {
		}
	
	}

	/**
	 * <p>Событие изменения данных</p>
	 */
	export interface ModelEvent {
		/**
		 * @description <p>Идентификатор события</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		id: string;
		/**
		 * @description <p>Идентификаторы предыдущих событий в цепочке</p>
		 * @type {string[]}
		 * @memberof ModelEvent
		 */
		prevEventIds?: string[];
		/**
		 * @description <p>Идентификатор сущности</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		entityId: string;
		/**
		 * @description <p>Тип события</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		'type': string;
		/**
		 * @description <p>Дата и время создания</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		createdAt: string;
		/**
		 * @description <p>Версия хранилища к которой относится событие</p>
		 * @type {number}
		 * @memberof ModelEvent
		 */
		storeVersion?: number;
		/**
		 * @description <p>Идентификатор МО</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Идентификатор пользователя, создавшего событие</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		userId?: string;
		/**
		 * @description <p>Дополнительные данные события в JSON</p>
		 * @type {string}
		 * @memberof ModelEvent
		 */
		payload?: string;
	}

	export interface MunicipalEntity extends Api.Entity {
		/**
		 * @description <p>Наименование исполнительного органа</p>
		 * @type {string}
		 * @memberof MunicipalEntity
		 */
		name: string;
		/**
		 * @description <p>Индекс</p>
		 * @type {number}
		 * @memberof MunicipalEntity
		 */
		index: number;
		/**
		 * @description <p>Код муниципального образования в справочнике КЛАДР</p>
		 * @type {string}
		 * @memberof MunicipalEntity
		 */
		kladrCode?: string;
	}

	export interface MunicipalEntityGetById200Response extends Api.ObjectResponse {
		object: Api.MunicipalEntity;
	}

	export interface MunicipalEntityGetList200Response extends Api.PaginatedResponse {
		items: Api.MunicipalEntity[];
	}

	export type MunicipalEntityGetListDirection =
		'asc' |
		'desc'
	
	export namespace MunicipalEntityGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type MunicipalEntityGetListOrderBy =
		'name' |
		'index' |
		'createdAt'
	
	export namespace MunicipalEntityGetListOrderBy {
		export enum Enum {
			Name = 'name',
			Index = 'index',
			CreatedAt = 'createdAt'
		}
	}

	/**
	 * <p>Результат операции, возвращающей один объект</p>
	 */
	export interface ObjectResponse {
		/**
		 * @description <p>Успешный результат операции</p>
		 * @type {Api.ObjectResponse.Result}
		 * @memberof ObjectResponse
		 */
		result: Api.ObjectResponse.Result;
		/**
		 * @description <p>Объект, возвращаемый в результате</p>
		 * @type {Api.ObjectResponse.Object}
		 * @memberof ObjectResponse
		 */
		object: Api.ObjectResponse.Object;
	}
	
	/**
	 * @export
	 * @namespace ObjectResponse
	 */
	export namespace ObjectResponse {
		/**
		 * <p>Успешный результат операции</p>
		 */
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
		/**
		 * <p>Объект, возвращаемый в результате</p>
		 */
		export interface Object {
		}
	
	}

	export interface PaginatedResponse {
		/**
		 * @description <p>Результат операции</p>
		 * @type {Api.PaginatedResponse.Result}
		 * @memberof PaginatedResponse
		 */
		result: Api.PaginatedResponse.Result;
		/**
		 * @description <p>Порядковый номер начальной записи. Начинается с нуля.</p>
		 * @type {number}
		 * @memberof PaginatedResponse
		 */
		'from': number;
		/**
		 * @description <p>Количество записей в ответе</p>
		 * @type {number}
		 * @memberof PaginatedResponse
		 */
		count: number;
		/**
		 * @description <p>Общее количество записей в базе соответствующих фильтру</p>
		 * @type {number}
		 * @memberof PaginatedResponse
		 */
		total: number;
		items: Api.PaginatedResponse.Item[];
	}
	
	/**
	 * @export
	 * @namespace PaginatedResponse
	 */
	export namespace PaginatedResponse {
		/**
		 * <p>Результат операции</p>
		 */
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
		/**
		 * <p>Список записей</p>
		 */
		export interface Item {
		}
	
	}

	export interface PrintableDataForIdentityCard {
		/**
		 * @description <p>Месяц идентификационной карты</p>
		 * @type {number}
		 * @memberof PrintableDataForIdentityCard
		 * minimum: 0
		 * maximum: 11
		 */
		month: number;
		/**
		 * @description <p>Год идентификационной карты</p>
		 * @type {number}
		 * @memberof PrintableDataForIdentityCard
		 * minimum: 2022
		 */
		year: number;
		/**
		 * @description <p>ID гражданина</p>
		 * @type {string}
		 * @memberof PrintableDataForIdentityCard
		 */
		citizenId: string;
		/**
		 * @description <p>ID пункта выдачи карточки</p>
		 * @type {string}
		 * @memberof PrintableDataForIdentityCard
		 */
		cardIssuePointId?: string;
	}

	/**
	 * <p>Запись для одной категории товара в продуктовом плане</p>
	 */
	export interface ProductReport {
		/**
		 * @description <p>Продовольственная категория</p>
		 * @type {Api.ProductReport.Category}
		 * @memberof ProductReport
		 */
		category: Api.ProductReport.Category;
		/**
		 * @description <p>Поставка</p>
		 * @type {number}
		 * @memberof ProductReport
		 */
		supply: number;
		/**
		 * @description <p>Фактическое потребление</p>
		 * @type {number}
		 * @memberof ProductReport
		 */
		consumption: number;
		/**
		 * @description <p>Остаток</p>
		 * @type {number}
		 * @memberof ProductReport
		 */
		balance: number;
	}
	
	/**
	 * @export
	 * @namespace ProductReport
	 */
	export namespace ProductReport {
		/**
		 * <p>Продовольственная категория</p>
		 */
		export type Category =
			'BREAD' |
			'MEAT' |
			'FATS' |
			'VEGETABLES' |
			'SALT' |
			'GROATS' |
			'FISH' |
			'MILK' |
			'SUGAR' |
			'EGGS' |
			'TOILET_SOAP' |
			'LAUNDRY_SOAP' |
			'DETERGENTS' |
			'MATCHES' |
			'KEROSENE'
		
		export namespace Category {
			export enum Enum {
				BREAD = 'BREAD',
				MEAT = 'MEAT',
				FATS = 'FATS',
				VEGETABLES = 'VEGETABLES',
				SALT = 'SALT',
				GROATS = 'GROATS',
				FISH = 'FISH',
				MILK = 'MILK',
				SUGAR = 'SUGAR',
				EGGS = 'EGGS',
				TOILETSOAP = 'TOILET_SOAP',
				LAUNDRYSOAP = 'LAUNDRY_SOAP',
				DETERGENTS = 'DETERGENTS',
				MATCHES = 'MATCHES',
				KEROSENE = 'KEROSENE'
			}
		}
	
	}

	export interface ProductSuppliesAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданной записи о поставке</p>
		 * @type {string}
		 * @memberof ProductSuppliesAdd200Response
		 */
		id: string;
	}

	export interface ProductSuppliesFormReport200Response extends Api.SuccessResponse {
		items: Api.ProductReport[];
	}

	export interface ProductSuppliesGetList200Response extends Api.PaginatedResponse {
		items: Api.ProductSupply[];
	}

	/**
	 * <p>Запись о поставке</p>
	 */
	export interface ProductSupply extends Api.Entity {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof ProductSupply
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Количество</p>
		 * @type {number}
		 * @memberof ProductSupply
		 */
		amount: number;
		/**
		 * @description <p>Продовольственная категория</p>
		 * @type {Api.ProductSupply.Category}
		 * @memberof ProductSupply
		 */
		category: Api.ProductSupply.Category;
	}
	
	/**
	 * @export
	 * @namespace ProductSupply
	 */
	export namespace ProductSupply {
		/**
		 * <p>Продовольственная категория</p>
		 */
		export type Category =
			'BREAD' |
			'MEAT' |
			'FATS' |
			'VEGETABLES' |
			'SALT' |
			'GROATS' |
			'FISH' |
			'MILK' |
			'SUGAR' |
			'EGGS' |
			'TOILET_SOAP' |
			'LAUNDRY_SOAP' |
			'DETERGENTS' |
			'MATCHES' |
			'KEROSENE'
		
		export namespace Category {
			export enum Enum {
				BREAD = 'BREAD',
				MEAT = 'MEAT',
				FATS = 'FATS',
				VEGETABLES = 'VEGETABLES',
				SALT = 'SALT',
				GROATS = 'GROATS',
				FISH = 'FISH',
				MILK = 'MILK',
				SUGAR = 'SUGAR',
				EGGS = 'EGGS',
				TOILETSOAP = 'TOILET_SOAP',
				LAUNDRYSOAP = 'LAUNDRY_SOAP',
				DETERGENTS = 'DETERGENTS',
				MATCHES = 'MATCHES',
				KEROSENE = 'KEROSENE'
			}
		}
	
	}

	/**
	 * <p>Общие поля пользователя</p>
	 */
	export interface ProductSupplyCommonFields {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof ProductSupplyCommonFields
		 */
		dataEntryDate?: string;
		/**
		 * @description <p>Количество</p>
		 * @type {number}
		 * @memberof ProductSupplyCommonFields
		 */
		amount?: number;
		/**
		 * @description <p>Продовольственная категория</p>
		 * @type {Api.ProductSupplyCommonFields.Category}
		 * @memberof ProductSupplyCommonFields
		 */
		category?: Api.ProductSupplyCommonFields.Category;
	}
	
	/**
	 * @export
	 * @namespace ProductSupplyCommonFields
	 */
	export namespace ProductSupplyCommonFields {
		/**
		 * <p>Продовольственная категория</p>
		 */
		export type Category =
			'BREAD' |
			'MEAT' |
			'FATS' |
			'VEGETABLES' |
			'SALT' |
			'GROATS' |
			'FISH' |
			'MILK' |
			'SUGAR' |
			'EGGS' |
			'TOILET_SOAP' |
			'LAUNDRY_SOAP' |
			'DETERGENTS' |
			'MATCHES' |
			'KEROSENE'
		
		export namespace Category {
			export enum Enum {
				BREAD = 'BREAD',
				MEAT = 'MEAT',
				FATS = 'FATS',
				VEGETABLES = 'VEGETABLES',
				SALT = 'SALT',
				GROATS = 'GROATS',
				FISH = 'FISH',
				MILK = 'MILK',
				SUGAR = 'SUGAR',
				EGGS = 'EGGS',
				TOILETSOAP = 'TOILET_SOAP',
				LAUNDRYSOAP = 'LAUNDRY_SOAP',
				DETERGENTS = 'DETERGENTS',
				MATCHES = 'MATCHES',
				KEROSENE = 'KEROSENE'
			}
		}
	
	}

	export interface RegistrationCheckCode200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Валидность кода</p>
		 * @type {boolean}
		 * @memberof RegistrationCheckCode200Response
		 */
		valid: boolean;
	}

	export interface RegistrationCheckCodeRequest {
		/**
		 * @description <p>Email пользователя, которым пытаемся авторизоваться или зарегистрироваться</p>
		 * @type {string}
		 * @memberof RegistrationCheckCodeRequest
		 */
		email: string;
		/**
		 * @description <p>Код регистрации</p>
		 * @type {string}
		 * @memberof RegistrationCheckCodeRequest
		 */
		authCode: string;
	}

	export interface RegistrationGenerateCode200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Код саморегистрации</p>
		 * @type {string}
		 * @memberof RegistrationGenerateCode200Response
		 */
		code: string;
	}

	export interface RegistrationSelfRegisterRequest {
		/**
		 * @description <p>Данные для создания пользователя</p>
		 * @type {Api.SelfRegisterUserOpts}
		 * @memberof RegistrationSelfRegisterRequest
		 */
		userOpts: Api.SelfRegisterUserOpts;
		/**
		 * @description <p>Код регистрации</p>
		 * @type {string}
		 * @memberof RegistrationSelfRegisterRequest
		 */
		authCode: string;
	}

	/**
	 * <p>Роль пользователя</p>
	 */
	export interface Role extends Api.Entity {
		/**
		 * @description <p>Имя роли</p>
		 * @type {string}
		 * @memberof Role
		 */
		name: string;
		/**
		 * @description <p>Описание роли</p>
		 * @type {string}
		 * @memberof Role
		 */
		description?: string;
		/**
		 * @description <p>Список разрешений</p>
		 * @type {string[]}
		 * @memberof Role
		 */
		permissions: string[];
		/**
		 * @description <p>Тип роли</p>
		 * @type {Api.Role.Type}
		 * @memberof Role
		 */
		'type': Api.Role.Type;
	}
	
	/**
	 * @export
	 * @namespace Role
	 */
	export namespace Role {
		/**
		 * <p>Тип роли</p>
		 */
		export type Type =
			'admin' |
			'operator' |
			'moderator' |
			'anonym'
		
		export namespace Type {
			export enum Enum {
				Admin = 'admin',
				Operator = 'operator',
				Moderator = 'moderator',
				Anonym = 'anonym'
			}
		}
	
	}

	export interface RolesGetById200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Роль пользователя</p>
		 * @type {Api.Role}
		 * @memberof RolesGetById200Response
		 */
		object: Api.Role;
	}

	export interface RolesGetList200Response extends Api.ListResponse {
		items: Api.Role[];
	}

	export interface SalesPoint extends Api.Entity {
		/**
		 * @description <p>Наименование хозяйствующего субъекта, осуществляющего торговую деятельность</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		name?: string;
		/**
		 * @description <p>ИНН хозяйствующего субъекта</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		inn?: string;
		/**
		 * @description <p>Тип</p>
		 * @type {Api.SalesPoint.Type}
		 * @memberof SalesPoint
		 */
		'type'?: Api.SalesPoint.Type;
		/**
		 * @description <p>Возможности по прикреплению населения (тыс. чел.)</p>
		 * @type {number}
		 * @memberof SalesPoint
		 */
		maxPopulation?: number;
		/**
		 * @description <p>Отметка об уведомлении</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		notificationMark?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		locality: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		comment?: string;
		/**
		 * @description <p>Площадь объекта</p>
		 * @type {number}
		 * @memberof SalesPoint
		 */
		area: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof SalesPoint
		 */
		responsiblePersonName?: string;
	}
	
	/**
	 * @export
	 * @namespace SalesPoint
	 */
	export namespace SalesPoint {
		/**
		 * <p>Тип</p>
		 */
		export type Type =
			'FOOD' |
			'NON_FOOD' |
			'MIXED'
		
		export namespace Type {
			export enum Enum {
				FOOD = 'FOOD',
				NONFOOD = 'NON_FOOD',
				MIXED = 'MIXED'
			}
		}
	
	}

	/**
	 * <p>Общие поля торгового объекта</p>
	 */
	export interface SalesPointCommonFields {
		/**
		 * @description <p>Наименование хозяйствующего субъекта, осуществляющего торговую деятельность</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		name?: string;
		/**
		 * @description <p>ИНН хозяйствующего субъекта</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		inn?: string;
		/**
		 * @description <p>Тип</p>
		 * @type {Api.SalesPointCommonFields.Type}
		 * @memberof SalesPointCommonFields
		 */
		'type'?: Api.SalesPointCommonFields.Type;
		/**
		 * @description <p>Возможности по прикреплению населения (тыс. чел.)</p>
		 * @type {number}
		 * @memberof SalesPointCommonFields
		 */
		maxPopulation?: number;
		/**
		 * @description <p>Отметка об уведомлении</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		notificationMark?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		locality?: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		comment?: string;
		/**
		 * @description <p>Площадь объекта</p>
		 * @type {number}
		 * @memberof SalesPointCommonFields
		 */
		area?: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof SalesPointCommonFields
		 */
		responsiblePersonName?: string;
	}
	
	/**
	 * @export
	 * @namespace SalesPointCommonFields
	 */
	export namespace SalesPointCommonFields {
		/**
		 * <p>Тип</p>
		 */
		export type Type =
			'FOOD' |
			'NON_FOOD' |
			'MIXED'
		
		export namespace Type {
			export enum Enum {
				FOOD = 'FOOD',
				NONFOOD = 'NON_FOOD',
				MIXED = 'MIXED'
			}
		}
	
	}

	export interface SalesPointGetById200Response {
		/**
		 * @description <p>Успешный результат операции</p>
		 * @type {Api.ObjectResponse.Result}
		 * @memberof SalesPointGetById200Response
		 */
		result: Api.ObjectResponse.Result;
		object: Api.SalesPoint;
	}

	export interface SalesPointsAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданного торгового объекта</p>
		 * @type {string}
		 * @memberof SalesPointsAdd200Response
		 */
		id: string;
	}

	export interface SalesPointsGetList200Response extends Api.PaginatedResponse {
		items: Api.SalesPoint[];
	}

	export type SalesPointsGetListDirection =
		'asc' |
		'desc'
	
	export namespace SalesPointsGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type SalesPointsGetListOrderBy =
		'createdAt'
	
	export namespace SalesPointsGetListOrderBy {
		export enum Enum {
			CreatedAt = 'createdAt'
		}
	}

	/**
	 * <p>Параметры для саморегистрации пользователя</p>
	 */
	export interface SelfRegisterUserOpts {
		/**
		 * @description <p>Email пользователя, он же является логином</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		email: string;
		/**
		 * @description <p>Пароль пользователя</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		password: string;
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		name: string;
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		surname: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		patronymic?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		municipalEntityId: string;
		/**
		 * @description <p>Идентификатор контрольного вопроса</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		controlQuestionId: string;
		/**
		 * @description <p>Правильный ответ на выбранный контрольный вопрос</p>
		 * @type {string}
		 * @memberof SelfRegisterUserOpts
		 */
		controlAnswer: string;
	}

	/**
	 * <p>Успешный результат операции</p>
	 */
	export interface SuccessResponse {
		/**
		 * @description <p>Результат операции</p>
		 * @type {Api.SuccessResponse.Result}
		 * @memberof SuccessResponse
		 */
		result: Api.SuccessResponse.Result;
	}
	
	/**
	 * @export
	 * @namespace SuccessResponse
	 */
	export namespace SuccessResponse {
		/**
		 * <p>Результат операции</p>
		 */
		export type Result =
			'success' |
			'error'
		
		export namespace Result {
			export enum Enum {
				Success = 'success',
				Error = 'error'
			}
		}
	
	}

	export interface SyncCheckEvents200Response extends Api.SuccessResponse {
		eventIds: string[];
	}

	export interface SyncCountEvents200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Количество событий, подходящих под фильтр</p>
		 * @type {number}
		 * @memberof SyncCountEvents200Response
		 */
		count: number;
	}

	export interface SyncExportEvents200Response extends Api.PaginatedResponse {
		items: Api.ModelEvent[];
	}

	export type SyncExportEventsDirection =
		'asc' |
		'desc'
	
	export namespace SyncExportEventsDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type SyncExportEventsOrderBy =
		'version' |
		'versionAndCreatedAt' |
		'createdAt'
	
	export namespace SyncExportEventsOrderBy {
		export enum Enum {
			Version = 'version',
			VersionAndCreatedAt = 'versionAndCreatedAt',
			CreatedAt = 'createdAt'
		}
	}

	export interface SyncGetInfo200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор хранилища</p>
		 * @type {string}
		 * @memberof SyncGetInfo200Response
		 */
		id: string;
		/**
		 * @description <p>Идентификатор распределенной базы данных</p>
		 * @type {string}
		 * @memberof SyncGetInfo200Response
		 */
		clusterId: string;
		/**
		 * @description <p>Текущая версия хранилища</p>
		 * @type {number}
		 * @memberof SyncGetInfo200Response
		 */
		currentVersion?: number;
	}

	export interface SyncImportEvents200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Версия хранилища, которую получили загруженные события</p>
		 * @type {number}
		 * @memberof SyncImportEvents200Response
		 */
		version: number;
	}

	/**
	 * <p>Обновление приложения</p>
	 */
	export interface Update {
		/**
		 * @description <p>Версия</p>
		 * @type {string}
		 * @memberof Update
		 */
		version: string;
		/**
		 * @description <p>Обязательное обновление</p>
		 * @type {boolean}
		 * @memberof Update
		 */
		critical: boolean;
		/**
		 * @description <p>Дата выпуска</p>
		 * @type {string}
		 * @memberof Update
		 */
		releasedAt?: string;
		/**
		 * @description <p>Список изменений</p>
		 * @type {string[]}
		 * @memberof Update
		 */
		changes?: string[];
		downloads: Api.Update.Download[];
	}
	
	/**
	 * @export
	 * @namespace Update
	 */
	export namespace Update {
		export interface Download {
			/**
			 * @description <p>Платформа</p>
			 * @type {string}
			 * @memberof Download
			 */
			platform: string;
			/**
			 * @description <p>Ссылка</p>
			 * @type {string}
			 * @memberof Download
			 */
			link: string;
		}
	
	}

	/**
	 * <p>Параметры для обновления пункта выдачи карт</p>
	 */
	export interface UpdateCardIssuePoint {
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Номер пункта выдачи карт</p>
		 * @type {number}
		 * @memberof UpdateCardIssuePoint
		 */
		'number'?: number;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		locality?: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		comment?: string;
		/**
		 * @description <p>Количество окон</p>
		 * @type {number}
		 * @memberof UpdateCardIssuePoint
		 */
		windowsCount?: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof UpdateCardIssuePoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string | null}
		 * @memberof UpdateCardIssuePoint
		 */
		responsiblePersonId?: string | null;
	}

	/**
	 * <p>Параметры для обновления гражданина</p>
	 */
	export interface UpdateCitizen {
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		surname?: string;
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		name?: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		patronymic?: string;
		/**
		 * @description <p>Пол</p>
		 * @type {Api.UpdateCitizen.Sex}
		 * @memberof UpdateCitizen
		 */
		sex?: Api.UpdateCitizen.Sex;
		/**
		 * @description <p>Дата рождения</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		birthdate?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Населенный пункт</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		locality?: string;
		/**
		 * @description <p>Улица</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		street?: string;
		/**
		 * @description <p>Дом</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		house?: string;
		/**
		 * @description <p>Квартира</p>
		 * @type {string}
		 * @memberof UpdateCitizen
		 */
		appartment?: string;
		/**
		 * @description <p>Категория</p>
		 * @type {Api.UpdateCitizen.Category}
		 * @memberof UpdateCitizen
		 */
		category?: Api.UpdateCitizen.Category;
		documents?: Api.AddCitizenDocument[];
	}
	
	/**
	 * @export
	 * @namespace UpdateCitizen
	 */
	export namespace UpdateCitizen {
		/**
		 * <p>Пол</p>
		 */
		export type Sex =
			'MALE' |
			'FEMALE'
		
		export namespace Sex {
			export enum Enum {
				MALE = 'MALE',
				FEMALE = 'FEMALE'
			}
		}
	
		/**
		 * <p>Категория</p>
		 */
		export type Category =
			'CH' |
			'AB_M' |
			'AB_F' |
			'P_M' |
			'P_F'
		
		export namespace Category {
			export enum Enum {
				CH = 'CH',
				ABM = 'AB_M',
				ABF = 'AB_F',
				PM = 'P_M',
				PF = 'P_F'
			}
		}
	
	}

	/**
	 * <p>Коэффициент для категории граждан</p>
	 */
	export interface UpdateCitizenCategory {
		/**
		 * @description <p>Новый коэффициент для категории граждан</p>
		 * @type {number}
		 * @memberof UpdateCitizenCategory
		 * minimum: 0.001
		 */
		coefficient: number;
	}

	/**
	 * <p>Параметры для обновления нормы потребления</p>
	 */
	export interface UpdateConsumptionRate {
		/**
		 * @description <p>Средняя норма потребления в сутки</p>
		 * @type {number}
		 * @memberof UpdateConsumptionRate
		 */
		averageRate?: number;
		/**
		 * @description <p>Количество талонов категории на месяц</p>
		 * @type {number}
		 * @memberof UpdateConsumptionRate
		 * minimum: 0
		 * maximum: 31
		 */
		couponsCountPerMonth?: number;
	}

	/**
	 * <p>Системные настройки</p>
	 */
	export interface UpdateGlobalSettings {
		anonymousRoleId?: string;
		reportsCloseTime?: string;
		/**
		 * @type {number}
		 * @memberof UpdateGlobalSettings
		 * minimum: 0
		 * maximum: 31
		 */
		cardActivationDelay?: number;
	}

	/**
	 * <p>Параметры для обновления торгового объекта</p>
	 */
	export interface UpdateSalesPoint {
		/**
		 * @description <p>Наименование хозяйствующего субъекта, осуществляющего торговую деятельность</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		name?: string;
		/**
		 * @description <p>ИНН хозяйствующего субъекта</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		inn?: string;
		/**
		 * @description <p>Тип</p>
		 * @type {Api.UpdateSalesPoint.Type}
		 * @memberof UpdateSalesPoint
		 */
		'type'?: Api.UpdateSalesPoint.Type;
		/**
		 * @description <p>Возможности по прикреплению населения (тыс. чел.)</p>
		 * @type {number}
		 * @memberof UpdateSalesPoint
		 */
		maxPopulation?: number;
		/**
		 * @description <p>Отметка об уведомлении</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		notificationMark?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Название населенного пункта</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		locality?: string;
		/**
		 * @description <p>Название улицы</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		street?: string;
		/**
		 * @description <p>Номер дома</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		building?: string;
		/**
		 * @description <p>Как добраться</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		comment?: string;
		/**
		 * @description <p>Площадь объекта</p>
		 * @type {number}
		 * @memberof UpdateSalesPoint
		 */
		area?: number;
		/**
		 * @description <p>Режим работы</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		openingHours?: string;
		/**
		 * @description <p>Контактный телефон</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		phone?: string;
		/**
		 * @description <p>Ответственное лицо</p>
		 * @type {string}
		 * @memberof UpdateSalesPoint
		 */
		responsiblePersonName?: string;
	}
	
	/**
	 * @export
	 * @namespace UpdateSalesPoint
	 */
	export namespace UpdateSalesPoint {
		/**
		 * <p>Тип</p>
		 */
		export type Type =
			'FOOD' |
			'NON_FOOD' |
			'MIXED'
		
		export namespace Type {
			export enum Enum {
				FOOD = 'FOOD',
				NONFOOD = 'NON_FOOD',
				MIXED = 'MIXED'
			}
		}
	
	}

	export type UpdatesGetLatest200Response = Api.ObjectResponse | Api.UpdatesGetLatest200Response.ObjectValue | Api.SuccessResponse;
	
	/**
	 * @export
	 * @namespace UpdatesGetLatest200Response
	 */
	export namespace UpdatesGetLatest200Response {
		export interface ObjectValue {
			/**
			 * @description <p>Обновление приложения</p>
			 * @type {Api.Update}
			 * @memberof ObjectValue
			 */
			object: Api.Update;
		}
	
	}

	/**
	 * <p>Параметры для обновления пользователя</p>
	 */
	export interface UpdateUser {
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		name?: string;
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		surname?: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		patronymic?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Статус пользователя</p>
		 * @type {Api.UpdateUser.Status}
		 * @memberof UpdateUser
		 */
		status?: Api.UpdateUser.Status;
		/**
		 * @description <p>Идентификатор роли</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		roleId?: string;
		/**
		 * @description <p>Идентификатор контрольного вопроса</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		controlQuestionId?: string;
		/**
		 * @description <p>Идентификатор пункта выдачи карт</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		cardIssuePointId?: string;
		/**
		 * @description <p>Пароль пользователя</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		password?: string;
		/**
		 * @description <p>Правильный ответ на выбранный контрольный вопрос</p>
		 * @type {string}
		 * @memberof UpdateUser
		 */
		controlAnswer?: string;
	}
	
	/**
	 * @export
	 * @namespace UpdateUser
	 */
	export namespace UpdateUser {
		/**
		 * <p>Статус пользователя</p>
		 */
		export type Status =
			'active' |
			'blocked'
		
		export namespace Status {
			export enum Enum {
				Active = 'active',
				Blocked = 'blocked'
			}
		}
	
	}

	export interface UsedCardsStat extends Api.Entity {
		/**
		 * @description <p>Дата и время внесения данных</p>
		 * @type {string}
		 * @memberof UsedCardsStat
		 */
		dataEntryDate: string;
		/**
		 * @description <p>Идентификатор торгового объекта</p>
		 * @type {string}
		 * @memberof UsedCardsStat
		 */
		salesPointId: string;
		values: Api.UsedCardsStat.Values;
	}
	
	/**
	 * @export
	 * @namespace UsedCardsStat
	 */
	export namespace UsedCardsStat {
		export interface Values {
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'CH': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'AB_F': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_M': number;
			/**
			 * @type {number}
			 * @memberof Values
			 * minimum: 0
			 */
			'P_F': number;
		}
	
	}

	export interface UsedCardsStatsAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданной записи об использованных картах</p>
		 * @type {string}
		 * @memberof UsedCardsStatsAdd200Response
		 */
		id: string;
	}

	export interface UsedCardsStatsFormReport200Response extends Api.SuccessResponse {
		object: Api.UsedCardsStatsFormReport200Response.Object;
	}
	
	/**
	 * @export
	 * @namespace UsedCardsStatsFormReport200Response
	 */
	export namespace UsedCardsStatsFormReport200Response {
		export interface Object {
			groupedByME: Api.GroupedUsedCardsStat[];
			groupedBySP: Api.UsedCardsStatsFormReport200Response.Object.GroupedBySP;
		}
		
		/**
		 * @export
		 * @namespace Object
		 */
		export namespace Object {
			export interface GroupedBySP {
				/**
				 * @description <p>Порядковый номер начальной записи. Начинается с нуля.</p>
				 * @type {number}
				 * @memberof GroupedBySP
				 */
				'from': number;
				/**
				 * @description <p>Количество записей в ответе</p>
				 * @type {number}
				 * @memberof GroupedBySP
				 */
				count: number;
				/**
				 * @description <p>Общее количество записей в базе соответствующих фильтру</p>
				 * @type {number}
				 * @memberof GroupedBySP
				 */
				total: number;
				items: Api.GroupedUsedCardsStat[];
			}
		
		}
	
	}

	export type UsedCardsStatsFormReportDirection =
		'asc' |
		'desc'
	
	export namespace UsedCardsStatsFormReportDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type UsedCardsStatsFormReportOrderBy =
		'createdAt'
	
	export namespace UsedCardsStatsFormReportOrderBy {
		export enum Enum {
			CreatedAt = 'createdAt'
		}
	}

	/**
	 * <p>Пользователь</p>
	 */
	export interface User extends Api.Entity {
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof User
		 */
		name: string;
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof User
		 */
		surname: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof User
		 */
		patronymic?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof User
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof User
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Статус пользователя</p>
		 * @type {Api.User.Status}
		 * @memberof User
		 */
		status: Api.User.Status;
		/**
		 * @description <p>Идентификатор роли</p>
		 * @type {string}
		 * @memberof User
		 */
		roleId: string;
		/**
		 * @description <p>Идентификатор контрольного вопроса</p>
		 * @type {string}
		 * @memberof User
		 */
		controlQuestionId?: string;
		/**
		 * @description <p>Идентификатор пункта выдачи карт</p>
		 * @type {string}
		 * @memberof User
		 */
		cardIssuePointId?: string;
		/**
		 * @description <p>Email пользователя, он же является логином</p>
		 * @type {string}
		 * @memberof User
		 */
		email: string;
	}
	
	/**
	 * @export
	 * @namespace User
	 */
	export namespace User {
		/**
		 * <p>Статус пользователя</p>
		 */
		export type Status =
			'active' |
			'blocked'
		
		export namespace Status {
			export enum Enum {
				Active = 'active',
				Blocked = 'blocked'
			}
		}
	
	}

	/**
	 * <p>Общие поля пользователя</p>
	 */
	export interface UserCommonFields {
		/**
		 * @description <p>Имя</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		name?: string;
		/**
		 * @description <p>Фамилия</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		surname?: string;
		/**
		 * @description <p>Отчество</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		patronymic?: string;
		/**
		 * @description <p>Телефон</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		phone?: string;
		/**
		 * @description <p>Идентификатор муниципального образования</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		municipalEntityId?: string;
		/**
		 * @description <p>Статус пользователя</p>
		 * @type {Api.UserCommonFields.Status}
		 * @memberof UserCommonFields
		 */
		status?: Api.UserCommonFields.Status;
		/**
		 * @description <p>Идентификатор роли</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		roleId?: string;
		/**
		 * @description <p>Идентификатор контрольного вопроса</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		controlQuestionId?: string;
		/**
		 * @description <p>Идентификатор пункта выдачи карт</p>
		 * @type {string}
		 * @memberof UserCommonFields
		 */
		cardIssuePointId?: string;
	}
	
	/**
	 * @export
	 * @namespace UserCommonFields
	 */
	export namespace UserCommonFields {
		/**
		 * <p>Статус пользователя</p>
		 */
		export type Status =
			'active' |
			'blocked'
		
		export namespace Status {
			export enum Enum {
				Active = 'active',
				Blocked = 'blocked'
			}
		}
	
	}

	export interface UsersAdd200Response extends Api.SuccessResponse {
		/**
		 * @description <p>Идентификатор созданного пользователя</p>
		 * @type {string}
		 * @memberof UsersAdd200Response
		 */
		id: string;
	}

	export interface UsersGetById200Response extends Api.ObjectResponse {
		/**
		 * @description <p>Пользователь</p>
		 * @type {Api.User}
		 * @memberof UsersGetById200Response
		 */
		object: Api.User;
	}

	export interface UsersGetControlQuestions200Response extends Api.ListResponse {
		items: Api.ControlQuestion[];
	}

	export interface UsersGetList200Response extends Api.PaginatedResponse {
		items: Api.User[];
	}

	export type UsersGetListDirection =
		'asc' |
		'desc'
	
	export namespace UsersGetListDirection {
		export enum Enum {
			Asc = 'asc',
			Desc = 'desc'
		}
	}

	export type UsersGetListOrderBy =
		'createdAt' |
		'email'
	
	export namespace UsersGetListOrderBy {
		export enum Enum {
			CreatedAt = 'createdAt',
			Email = 'email'
		}
	}

	export type UsersGetListStatuses =
		'active' |
		'blocked'
	
	export namespace UsersGetListStatuses {
		export enum Enum {
			Active = 'active',
			Blocked = 'blocked'
		}
	}

}

